import { createContext, useContext, useState, ReactNode } from "react";

const STORAGE_KEY = "adminUserOverride";

interface AdminOverrideContextType {
  overrideEmail: string | null;
  setOverrideEmail: (email: string | null) => void;
}

const AdminOverrideContext = createContext<AdminOverrideContextType | null>(null);

export function AdminOverrideProvider({ children }: { children: ReactNode }) {
  const [overrideEmail, setOverrideEmailState] = useState<string | null>(() => {
    // Initialize from localStorage
    if (typeof window !== "undefined") {
      return localStorage.getItem(STORAGE_KEY);
    }
    return null;
  });

  // Persist to localStorage
  const setOverrideEmail = (email: string | null) => {
    setOverrideEmailState(email);
    if (email) {
      localStorage.setItem(STORAGE_KEY, email);
    } else {
      localStorage.removeItem(STORAGE_KEY);
    }
  };

  return (
    <AdminOverrideContext.Provider value={{ overrideEmail, setOverrideEmail }}>
      {children}
    </AdminOverrideContext.Provider>
  );
}

export function useAdminOverride() {
  const context = useContext(AdminOverrideContext);
  if (!context) {
    throw new Error("useAdminOverride must be used within AdminOverrideProvider");
  }
  return context;
}
